// extracted by mini-css-extract-plugin
module.exports = {"removeButton":"RemoveButton_removeButton__1ev1b","removeButtonToggle":"RemoveButton_removeButtonToggle__2jkN9"};